import {
  type Condition,
  type ConditionsGroup,
  type ConditionSimple,
} from '../../types';

export function isConditionsGroup(
  condition: Condition,
): condition is ConditionsGroup {
  return 'operator' in condition;
}

export function isConditionSimple(
  condition: Condition,
): condition is ConditionSimple {
  return !isConditionsGroup(condition);
}

export function isMultiOperator(operator: string): boolean {
  return operator === 'in' || operator === 'notin';
}

export function isValueLessOperator(operator: string): boolean {
  return operator === 'notset' || operator === 'any';
}

export function isDaysAgoOperator(operator: string): boolean {
  return operator.startsWith('daysago');
}

export function isBetweenOperator(operator: string): boolean {
  return operator === 'between' || operator === 'daysago between';
}

/*
async function test<T>(pr: Promise<T>): Promise<{ id: number; } & T> {
  const res = await pr;
  return {
    id: 1,
    ...res,
  };
}
*/
